import PonchoIcon from "./PonchoIcon";

export default function CertificadoAmbienteIcon({ ...props }) {
  return <PonchoIcon name="ambiente-cert" {...props} />;
}
